import Loading from 'components/Loading';
import RightGif from 'components/RightGif/RightGif';
import Page404 from 'pages/Error';
import HomePage from 'pages/Home';
import HistoryPage from 'pages/Home/history';
import PrizeStructure from 'pages/Home/prizeStructure';
import RulePage from 'pages/Home/rule';
import { Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import favicon from './assets/images/favicon.png';
import { SITE } from './config/config';

const favicons = {
  open88: favicon
};

function Apps() {
  useEffect(() => {
    const faviconElement =
      document.querySelector("link[rel*='icon']") || document.createElement('link');
    faviconElement.type = 'image/png';
    faviconElement.rel = 'icon';
    faviconElement.href = favicons[SITE];
  }, []);

  return (
    <RecoilRoot>
      <BrowserRouter>
        <Suspense fallback={<Loading />}>
          <RightGif />
          <Routes>
            <Route exact path="/" element={<HomePage />} />
            <Route path="/prediction" element={<HomePage />} />
            <Route path="/rule" element={<RulePage />} />
            <Route path="/prize-structure" element={<PrizeStructure />} />
            <Route path="/history" element={<HistoryPage />} />
            {/* Add other routes here */}
            <Route path="*" element={<Page404 />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </RecoilRoot>
  );
}

export default Apps;
